import { cn } from '@/lib/utils';

interface FallbackWidgetProps {
  widgetType: string;
  /** Stable block id from the server (no payload dump). */
  widgetId?: string;
  error?: string;
  className?: string;
}

export function FallbackWidget({ widgetType, widgetId, error, className }: FallbackWidgetProps) {
  if (import.meta.env.DEV) {
    console.warn(`[WidgetRenderer] Fallback widget: ${widgetType}`, widgetId);
  }

  return (
    <div
      className={cn(
        'rounded-lg border border-dashed border-muted-foreground/40 bg-muted/40 p-3 text-xs',
        className,
      )}
      role="status"
      aria-label="Unsupported widget"
    >
      <p className="font-medium text-foreground">Unsupported widget</p>
      <p className="mt-1 font-mono text-muted-foreground">
        {widgetType}
        {widgetId ? ` · ${widgetId}` : ''}
      </p>
      {error ? <p className="mt-2 text-muted-foreground opacity-80">{error}</p> : null}
    </div>
  );
}
